import {extendObservable, computed} from 'mobx'
import firebase from '../firebase'

class ToolStore {
    constructor(authStore) {
        extendObservable(this, {
            defaultTools: [],
            defaultStages: [],
            defaultTags: [],
            defaultEffort: null,
            defaultImpact: null,
            toolOrder: computed(() =>{
                let orderedTools = []
                let toolSet = this.authStore.auth.primaryTeam.tools ? this.authStore.auth.primaryTeam.tools : this.defaultTools
                toolSet.forEach(t => {
                    let key = Object.keys(t)[0]
                    orderedTools.push(key)                    
                })
                return orderedTools
            }),
            allTools: computed(() =>{
                let allTools = {}
                let toolSet = this.authStore.auth.primaryTeam.tools ? this.authStore.auth.primaryTeam.tools : this.defaultTools
                toolSet.forEach(t => {
                    let key = Object.keys(t)[0]
                    allTools[key] = t[key].tools
                })
                return allTools
            }),
            allToolShowNames: computed(() =>{
                let showNames = {}
                let toolSet = this.authStore.auth.primaryTeam.tools ? this.authStore.auth.primaryTeam.tools : this.defaultTools
                toolSet.forEach(t => {
                    let key = Object.keys(t)[0]
                    showNames[key] = t[key].showName
                })
                return showNames
            }),
            stages: computed(() =>{
                let stageSet = this.authStore.auth.primaryTeam.stages ? this.authStore.auth.primaryTeam.stages : this.defaultStages
                return stageSet
            }),
            tags: computed(() =>{
                let tagSet = this.authStore.auth.primaryTeam.tags ? this.authStore.auth.primaryTeam.tags : this.defaultTags
                return tagSet
            }),
            effortGuideline: computed(() =>{
                let effortSet = this.authStore.auth.primaryTeam.effortGuideline ? this.authStore.auth.primaryTeam.effortGuideline : this.defaultEffort
                return effortSet
            }),
            impactGuideline: computed(() =>{
                let impactSet = this.authStore.auth.primaryTeam.impactGuideline ? this.authStore.auth.primaryTeam.impactGuideline : this.defaultImpact
                return impactSet
            }),
        })
        this.authStore = authStore
        this.unwatchAuth = authStore.watchAuth(user => {
            if(user){
                firebase.database().ref().child('tools').once('value',snap => {
                    if(snap.exists()){
                        this.defaultTools = snap.val()
                    }            
                }, error => {
                    console.error(error)
                }).then(()=> {
                    return firebase.database().ref().child('stages').once('value',snap => {
                        if(snap.exists()){
                            this.defaultStages = snap.val()
                        }            
                    }, error => {
                        console.error(error)
                    })
                }).then(()=> {
                    return firebase.database().ref().child('tags').once('value',snap => {
                        if(snap.exists()){
                            this.defaultTags = snap.val()
                        }            
                    }, error => {
                        console.error(error)
                    })
                }).then(()=> {
                    return firebase.database().ref().child('_defaults').once('value',snap => {
                        if(snap.exists()){
                            this.defaultEffort = snap.val().effortGuideline
                            this.defaultImpact = snap.val().impactGuideline
                            // console.log('defaults:', this.defaultImpact)
                        }            
                    }, error => {
                        console.error(error)
                    })
                })
            }
        })
    }
}

export default ToolStore



// WEBPACK FOOTER //
// ./src/stores/ToolStore.js